import React from "react";

/**
 * Symbol when a table row cannot be toggled.
 * @returns Text representing that a row cannot be toggled.
 */
const ToggleDisabled = () => <span className="grid__toggle-disabled">&mdash;</span>;

export default ToggleDisabled;
